import { useEffect } from "react"
import { useLocation } from "@tanstack/react-router"

// The banner links here rather than raising the limit for the reader: money
// only moves once someone types a number.
export const AI_LIMIT_FIELD_ID = "ai-overage-limit"
export const AI_LIMIT_FIELD_HASH = `#${AI_LIMIT_FIELD_ID}`

// Scrolls the overage limit into view and selects it, so arriving from the
// paused banner puts the cursor on the one field that starts AI again.
export function useFocusAiLimitField(ready: boolean) {
	const { hash } = useLocation()

	useEffect(() => {
		if (!ready || hash !== AI_LIMIT_FIELD_ID) return
		const frame = requestAnimationFrame(() => {
			const container = document.getElementById(AI_LIMIT_FIELD_ID)
			container?.scrollIntoView({ block: "center", behavior: "smooth" })
			const input = container?.querySelector("input[name='cap']")
			if (input instanceof HTMLInputElement) {
				input.focus()
				input.select()
			}
		})
		return () => cancelAnimationFrame(frame)
	}, [ready, hash])
}
